export const TomadaStatus = {
  Pending: {
    label: 'Disponível',
    color: '#57c278',
  },
  Finished: {
    label: 'Ocupada',
    color: '#eb3681',
  },
}
export default function (status) {
  for (const key in TomadaStatus) {
    const s = TomadaStatus[key]
    if (s.label === status) return TomadaStatus[key]
  }
}
